import React from "react";

import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { ApolloWrapper } from "../../apollo/ApolloWrapper";
import { ParallaxProvider } from "react-scroll-parallax";
import {
  PaymentCurrenciesWrapper,
  CurrencyWrapper,
  IntroducerWrapper,
  UserWrapper,
  FeedbackWrapper,
  CartWrapper,
} from "../../contexts";

import ErrorBoundary from "./error-boundary";

const element = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <ParallaxProvider>
        <ApolloWrapper>
          <PaymentCurrenciesWrapper>
            <CurrencyWrapper>
              <IntroducerWrapper>
                <UserWrapper>
                  <FeedbackWrapper>
                    <ErrorBoundary>
                      <CartWrapper>{element}</CartWrapper>
                    </ErrorBoundary>
                  </FeedbackWrapper>
                </UserWrapper>
              </IntroducerWrapper>
            </CurrencyWrapper>
          </PaymentCurrenciesWrapper>
        </ApolloWrapper>
      </ParallaxProvider>
    </ThemeProvider>
  );
};

export default element;
